"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEVICE_NAME_HEADER = exports.SERVICE_NAME_HEADER = void 0;
exports.SERVICE_NAME_HEADER = 'travel-service-name';
exports.DEVICE_NAME_HEADER = 'travel-device-name';
